import * as yup from 'yup'
import {
  addFleetAPIStructure,
  addFleetBasicStructure,
} from '../../../../validation/fleet'

export const basicValidation = yup.object().shape(addFleetBasicStructure)

export const apiValidation = yup.object().shape(addFleetAPIStructure)
